export default __webpack_public_path__ + "static/media/TVinsure-Covid-Card-Sei.035f5dc5.jpg";